import angular from 'angular';

import { AngularCompleteModalContent } from './AngularCompleteModalContent';

const MODULE_NAME = 'app.global.components.dashboard-sidebar.onboarding-checklist.complete-modal';

angular.module(MODULE_NAME, []).component('completeModalContent', AngularCompleteModalContent);

export default MODULE_NAME;
